import store from '../store';

export default class Tabview {
  constructor(api) {
    this.api = api
  }

  load() {
    return this.api.call_busy({
      '_class': 'Tabview',
      '_method': 'load',
    }).then(response => {
      // TODO: validation
      let tabview = response
      // parse TabView Custom Views
      tabview = tabview.custom_views && tabview.custom_views.custom_view ? (tabview.custom_views.custom_view.length ? tabview.custom_views.custom_view : [tabview.custom_views.custom_view]) : []
      tabview = tabview.map(a => ({
        ...a._attributes,
        titles: (a.titles && a.titles.title ? (a.titles.title.length ? a.titles.title : [a.titles.title] ) : []).map(a => ({ ...a._attributes })),
        fields: (a.field ? (a.field.length ? a.field : [a.field] ) : []).map(a => ({ ...a._attributes })).sort((a, b) => a.position - b.position),
      })).sort((a, b) => a.position - b.position)
      
      store.commit('setTabview', tabview)
    })
  }
}